import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private searchBarVisible = new BehaviorSubject<boolean>(false);
  public searchBarVisible$ = this.searchBarVisible.asObservable();

  private cancelModalVisible = new BehaviorSubject<{
    visible: boolean;
    bookingId: string;
    bookingUniqueId: string;
    refundAmount: string;
  }>({
    visible: false,
    bookingId: '',
    bookingUniqueId: '',
    refundAmount: '',
  });
  public cancelModalVisible$ = this.cancelModalVisible.asObservable();

  public showSearchBarModal(): void {
    this.searchBarVisible.next(true);
  }

  public hideSearchBarModal(): void {
    this.searchBarVisible.next(false);
  }

  public showCancelModal(
    bookingId: string,
    bookingUniqueId: string,
    refundAmount: string
  ): void {
    this.cancelModalVisible.next({
      visible: true,
      bookingId,
      bookingUniqueId,
      refundAmount,
    });
  }

  public hideCancelModal(): void {
    this.cancelModalVisible.next({
      visible: false,
      bookingId: '',
      bookingUniqueId: '',
      refundAmount: '',
    });
  }
}
